import defaultBackground from '../assets/img/destinations/default.jpg';
import emiratesBackground from '../assets/img/destinations/ae.png';
import cyprusBackground from '../assets/img/destinations/cy.png';
import germanyBackground from '../assets/img/destinations/de.png';
import spainBackground from '../assets/img/destinations/es.png';
import franceBackground from '../assets/img/destinations/fr.png';
import unitedKingdomBackground from '../assets/img/destinations/gb.png';
import georgiaBackground from '../assets/img/destinations/ge.png';
import greeceBackground from '../assets/img/destinations/gr.jpg';
import italyBackground from '../assets/img/destinations/it.jpg';
import thailandBackground from '../assets/img/destinations/th.png';
import usaBackground from '../assets/img/destinations/us.jpg';

export const DESTINATION_CHANGE_EVENT = 'wobi-destination-change';
export const DETAILS_FORM_STORAGE_KEY = 'travel.details-form';
export const DEFAULT_DESTINATION_BACKGROUND = defaultBackground;

export const destinationBackgrounds = {
  'CYPRUS': cyprusBackground,
  'FRANCE': franceBackground,
  'GEORGIA': georgiaBackground,
  'GERMANY': germanyBackground,
  'GREECE': greeceBackground,
  'ITALY': italyBackground,
  'SPAIN': spainBackground,
  'THAILAND': thailandBackground,
  'UNITED ARAB EMIR': emiratesBackground,
  'UNITED KINGDOM': unitedKingdomBackground,
  'USA': usaBackground,
};

export const getActiveDestination = (targetCountries) => {
  if (!Array.isArray(targetCountries)) {
    return undefined;
  }
  return targetCountries[targetCountries.length - 1];
};

export const getDestinationBackground = (targetCountries) => {
  const activeDestination = getActiveDestination(targetCountries);
  return destinationBackgrounds[activeDestination] || DEFAULT_DESTINATION_BACKGROUND;
};

export const readPersistedDestinations = (storage = window.sessionStorage) => {
  try {
    const persistedForm = JSON.parse(storage.getItem(DETAILS_FORM_STORAGE_KEY));
    return Array.isArray(persistedForm?.values?.targetCountries) ?
      persistedForm.values.targetCountries : [];
  } catch (error) {
    return [];
  }
};

export const publishDestinationChange = (targetCountries) => {
  window.dispatchEvent(new CustomEvent(DESTINATION_CHANGE_EVENT, {
    detail: {targetCountries},
  }));
};